import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router";
import { errorMessage, platform } from "../lib/api";
import { Alert, Spinner } from "../components/ui";
import Markdown from "../components/Markdown";

type Doc = { document: string; title: string; version: string; published_at: string; body: string };

// Termenii platformei și DPA-ul: pagini publice (linkuri din formularul de înscriere și din banner).
export default function Legal() {
  const { doc } = useParams();
  const q = useQuery({ queryKey: ["legal", doc], queryFn: () => platform.get<Doc>(`/agreements/${doc}`) });
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-4 py-10">
        <div className="mb-8 flex items-center justify-between text-sm">
          <Link to="/" className="font-bold uppercase tracking-[0.3em] text-brand">shopcore</Link>
          <nav className="flex gap-4 text-slate-500">
            <Link to="/legal/terms" className="hover:text-slate-900">Termeni</Link>
            <Link to="/legal/dpa" className="hover:text-slate-900">DPA</Link>
          </nav>
        </div>
        {q.isLoading ? <Spinner /> : q.error ? <Alert>{errorMessage(q.error)}</Alert> : q.data && (
          <article>
            <h1 className="text-3xl font-extrabold tracking-tight">{q.data.title}</h1>
            <p className="mb-8 mt-1 text-sm text-slate-500">Versiunea {q.data.version}, în vigoare din {new Date(q.data.published_at).toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" })}</p>
            <Markdown>{q.data.body}</Markdown>
          </article>
        )}
      </div>
    </div>
  );
}
